<template>
  <div>
    <d-row>
      <d-col cols="4" class="pt-3 pb-3">
        <span>Airport:</span>
        <a :href="baseUrl + '/dashboard/airports/' + airportId" target="_blank" class="text-primary">
          {{ airportName }}
        </a>
      </d-col>

      <d-col cols="3" class="d-flex align-items-center">
        <d-checkbox
          inline
          v-model="parentShort.data[notRequiredField]"
          toggle>
            Not required
        </d-checkbox>
      </d-col>

      <d-col cols="5" class="d-flex align-items-center">
        <v-select
          :options="handlingAgents"
          v-model="selectedAgent"
          :reduce="agent => agent.id"
          placeholder="Select an agent"
          label="name"
          :maxItemsDisplay="100"
          class="w-75">
          <template slot="no-options">
            <template>There are no agents for the provided phrase&hellip;</template>
          </template>
        </v-select>

        <d-button
          theme="success"
          @click.prevent="setHandler()"
          class="w-25 ml-2">
          Set handler
        </d-button>
      </d-col>
    </d-row>

    <d-row
      v-if="!parentShort.data[notRequiredField]"
      class="pl-3 pr-3">
      <table class="table">
        <thead>
          <tr>
            <th>Name</th>
            <th>Phone</th>
            <th>Email</th>
            <th>Status</th>
            <th>Payment status</th>
            <th>Frequency</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(agent, index) of getFilteredHandlingAgents()"
            :key="airportName + '-handling-agent-' + index">
            <td class="align-middle">
              {{ agent.name }}
            </td>
            <td class="align-middle" style="width: 180px;">
              {{ agent.phone }}
            </td>
            <td class="align-middle" style="width: 180px;">
              {{ agent.email }}
            </td>
            <td class="align-middle" style="width: 200px;">
              <div>
                <d-checkbox
                  inline
                  toggle-small
                  v-model="parentShort.data[handlerRequestedField]"
                  toggle
                  class="is-warning">
                  Requested
                </d-checkbox>
              </div>

              <div>
                <d-checkbox
                  inline
                  toggle-small
                  v-model="parentShort.data[handlerConfirmedField]"
                  toggle>
                  Confirmed
                </d-checkbox>
              </div>
            </td>
            <td class="align-middle" style="width: 240px">
              <v-select
                :options="paymentStatusOptions"
                v-model="parentShort.data[handlerPaymentStatusField]"
                :reduce="option => option.value"
                placeholder="Select a status"
                :searchable="false"
                :filterabe="false"
                label="label"
                class="w-100 mt-2">
              </v-select>
            </td>
            <td class="align-middle" style="width: 120px;">
              {{ agent.handler_frequency }}
            </td>
          </tr>
          <tr v-if="!handlingAgents.length">
            <td
              colspan="6"
              class="text-center">
              <d-alert
                theme="warning"
                show>
                There are no available handling agents for this airport
              </d-alert>
            </td>
          </tr>
        </tbody>
      </table>
    </d-row>
  </div>
</template>

<script>
export default {
  name: 'flight-form-handlers',
  props: [
    'airportName',
    'airportId',
    'notRequiredField',
    'handlingAgents',
    'selectedHandlerField',
    'handlerRequestedField',
    'handlerConfirmedField',
    'handlerPaymentStatusField'
  ],
  computed: {
    baseUrl () {
      return window.location.protocol + '//' + window.location.host;
    },
    parentShort () {
      return this.$parent.$parent.$parent.$parent;
    },
    paymentStatusOptions () {
      return [{
        'label': 'Jet Team credit',
        'value': 'credit'
      }, {
        'label': 'Client to settle',
        'value': 'client_to_settle'
      }];
    }
  },
  data () {
    return {
      selectedAgent: null
    };
  },
  mounted () {
    this.selectedAgent = this.parentShort.data[this.selectedHandlerField];
  },
  methods: {
    setHandler () {
      this.parentShort.data[this.selectedHandlerField] = this.selectedAgent;
      this.parentShort.data[this.handlerRequestedField] = false;
      this.parentShort.data[this.handlerConfirmedField] = false;
      this.$forceUpdate();
    },
    getFilteredHandlingAgents () {
      return this.handlingAgents.filter(agent => agent.id === this.parentShort.data[this.selectedHandlerField]);
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
